import React, { useState, PropsWithChildren, useMemo } from 'react';
import { TabContainerContext } from './ContainerContext';

const TabContainer = ({ children }: PropsWithChildren<{}>) => {
  const [activeTab, setActiveTab] = useState('0');
  const context = useMemo(() => ({ activeTab, setActiveTab }), [activeTab]);
  return (
    <TabContainerContext.Provider value={context}>
      {children}
    </TabContainerContext.Provider>
  );
};
export default TabContainer;
